exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "._8wjaLC4Mwa_oa4T3hXxQY {\n  display: flex;\n  align-items: center;\n  margin-bottom: 25px;\n}\n\n._2Lloq8TQCrACG7yTWgz8sP {\n  flex: 1;\n  margin: 0px;\n}\n", "", {"version":3,"sources":["/home/forge/vf.leadpm.io/frontend/src/Screens/SubcontractorSubOrder/Components/Header/styles.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,oBAAoB;EACpB,oBAAoB;CACrB;;AAED;EACE,QAAQ;EACR,YAAY;CACb","file":"styles.css","sourcesContent":[".wrapper {\n  display: flex;\n  align-items: center;\n  margin-bottom: 25px;\n}\n\n.header {\n  flex: 1;\n  margin: 0px;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"wrapper": "_8wjaLC4Mwa_oa4T3hXxQY",
	"header": "_2Lloq8TQCrACG7yTWgz8sP"
};